import Vue from 'vue'
import 'babel-polyfill'
import promise from 'es6-promise';
promise.polyfill();
import App from './App'
import router from './router'
import store from 'store'
import Element from 'element-ui'
import './assets/scss/element-variables.scss';
import './assets/css/crm.css'
import 'font-awesome/css/font-awesome.min.css'
import 'viewerjs/dist/viewer.css'
import 'swiper/dist/css/swiper.css';
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import global from './store/modules/global';

//局部打印插件注册
import Print from 'service/print'
Vue.use(Print) // 注册

Vue.config.productionTip = false

let HOST = process.env.HOST
document.title = HOST == "dev" ? '伊顿云管理系统--开发' : HOST == "test" ? '伊顿云管理系统--测试' : '伊顿云管理'
if (self != top || window.process) {
    document.body.style.cssText = 'user-select:none;-webkit-user-select: none;'
}
/* 基础组件全局注册 */
const requireComponent = require.context(
    './components', // 其组件目录的相对路径
    false, // 是否查询其子目录
    /[A-Z]\w+(Tabs|Modal)\.(vue|js)$/ // 匹配基础组件文件名的正则表达式
)
requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName)
    // 获取组件的 PascalCase 命名
    const componentName = upperFirst(
        camelCase(
            // 获取和目录深度无关的文件名
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    )
    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
})


Vue.use(Element)

new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js